export default __webpack_public_path__ + "static/media/Najran.5741afa2.mp4";